import { render, staticRenderFns } from "./GoToStatisticsButton.vue?vue&type=template&id=2571e148&scoped=true&"
import script from "./GoToStatisticsButton.vue?vue&type=script&lang=js&"
export * from "./GoToStatisticsButton.vue?vue&type=script&lang=js&"
import style0 from "./GoToStatisticsButton.vue?vue&type=style&index=0&id=2571e148&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2571e148",
  null
  
)

export default component.exports